import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCOP-vE979eNzagGuLkisH_wPVomOVp1q4",
  authDomain: "efete-2b074.firebaseapp.com",
  projectId: "efete-2b074",
  storageBucket: "efete-2b074.firebasestorage.app",
  messagingSenderId: "392751074266",
  appId: "1:392751074266:web:1464e7f1f2ae6d57bf0ee3",
  measurementId: "G-Z5X0T1RC5F"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
